<template>
  <container class="manager">
    <v-row class="header-container">
      <v-col cols="12" md="4" lg="3">
        <v-card-title>{{
          $capitalize($tc("model.managers_managers"))
        }}</v-card-title>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn @click="getManagers()" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-text-field
          v-model="filter"
          :label="$capitalize($tc('model.managers_manager_search'))"
          prepend-icon="mdi-magnify"
          @keyup.enter="getManagers"
          :disable="loading"
          clearable
          single-line
          v-if="filter !== null"
        ></v-text-field>
        <v-btn v-else @click="filter = ''" icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>

      <v-col class="text-right">
        <scope-provider scope="service_managers.add">
          <v-btn @click="handleOpenDialog()" color="primary">
            <v-icon left>mdi-plus</v-icon
            >{{ $capitalize($tc("model.managers_new_manager")) }}
          </v-btn>
        </scope-provider>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="5"
          :disabled="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          :loading-text="$capitalize($tc('model.managers_loading'))"
        >
          <template v-slot:header.user_name>
            {{ $capitalize($tc("model.managers_name", 1)) }}
          </template>

          <template v-slot:header.lead_type_description>
            {{ $capitalize($tc("model.managers_services", 1)) }}
          </template>

          <template v-slot:header.actions>
            {{ $capitalize($tc("model.managers_actions", 1)) }}
          </template>

          <template v-slot:item.user_avatar="{ item }">
            <user-avatar
              :avatar_url="item.user_avatar"
              :user_name="item.user_name"
              size="35"
              :user_id="item.user_id"
            />
          </template>

          <template v-slot:item.lead_type_description="{ item }">
            <v-chip label value>{{ item.lead_type.description }}</v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div>
              <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-on="on" v-bind="attrs">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <scope-provider scope="service_managers.edit">
                    <v-list-item @click="handleEditManager(item.id)">
                      <v-icon left size="20">mdi-pencil</v-icon>
                      <v-list-item-title>{{
                        $capitalize($tc("model.managers_alter"))
                      }}</v-list-item-title>
                    </v-list-item>
                  </scope-provider>
                  <scope-provider scope="service_managers.delete">
                    <v-list-item
                      value="true"
                      @click="handleRemoveManager(item)"
                    >
                      <v-icon left size="20">mdi-delete</v-icon>
                      <v-list-item-title>{{
                        $capitalize($tc("model.managers_remove"))
                      }}</v-list-item-title>
                    </v-list-item>
                  </scope-provider>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>

        <v-dialog v-model="manager_dialog" max-width="500" persistent>
          <ManagerForm
            v-model="manager"
            :title="$capitalize($tc('model.managers_manager_data'))"
            @submit="handleSubmitForm"
            @close="handleCloseManagerDialog"
            :manager_id="edit_manager"
          ></ManagerForm>
        </v-dialog>

        <v-dialog v-model="confirm_dialog" max-width="300" persistent>
          <v-card>
            <v-card-title>
              {{ $capitalize($tc("model.managers_remove_manager")) }}?
              <v-spacer></v-spacer>
              <v-btn @click="confirm_dialog = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="loading_deleting_manager"
                text
                @click="confirm_dialog = false"
                >{{ $capitalize($tc("model.managers_no")) }}</v-btn
              >
              <v-btn
                :loading="loading_deleting_manager"
                color="red"
                dark
                @click="removeManager()"
                >{{ $capitalize($tc("model.managers_remove")) }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </container>
</template>

<script>
import {
  index as indexServiceManagers,
  show as showManagers,
  update as updateManagers,
  destroy as deleteManager
} from "../services/service_managers";
import ManagerForm from "../components/forms/ManagerForm";
import ScopeProvider from "../components/ScopeProvider";
import UserAvatar from "@/components/UserAvatar";

export default {
  components: { ManagerForm, ScopeProvider, UserAvatar },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "user_avatar",
        width: 100,
        align: "center",
        sortable: false
      },
      { text: "Nome", value: "user_name" },
      {
        text: "Serviços",
        value: "lead_type_description",
        // TODO: Corrigir ordenação da relação
        sortable: false
      },
      { text: "Acções", value: "actions", sortable: false }
    ],
    filter: null,
    loading: false,
    dialog: false,
    totalItems: 0,
    options: {
      itemsPerPage: 10,
      sortBy: ["user_name"],
      sortDesc: []
    },
    manager_dialog: false,
    manager: {},
    loading_service_types: false,
    service_type: [],
    confirm_dialog: false,
    confirm_manager: null,
    loading_deleting_manager: false,
    edit_manager: null
  }),
  methods: {
    handleCloseManagerDialog() {
      this.manager_dialog = false;
      this.edit_manager = null;
    },
    handleEditManager(manager_id) {
      this.edit_manager = manager_id;
      this.manager_dialog = true;
    },
    async removeManager() {
      this.loading_deleting_manager = true;

      try {
        await deleteManager(this.confirm_manager.id);
        this.items = this.items.filter(
          item => item.id !== this.confirm_manager.id
        );
        this.$store.commit("sendMessage", {
          text: "Gestor excluído com sucesso"
        });
        this.confirm_dialog = false;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível excluir o gestor",
          color: "red"
        });
      } finally {
        this.loading_deleting_manager = false;
      }
    },
    async getServiceTypes() {
      this.loading_service_types = true;
      this.service_types = [];

      try {
        this.service_types = await indexLeadTypes();
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar utilizadores",
          color: "red"
        });
      } finally {
        this.loading_service_types = false;
      }
    },
    async getManagers() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.loading = true;
      this.items = [];

      const response = await indexServiceManagers({
        orderBy: sortBy[0] ? sortBy[0] : "",
        sortDesc: sortDesc[0] ? sortBy[0] : "",
        page,
        perPage: itemsPerPage,
        filter: this.filter || ""
      });

      this.items = response.data;
      this.loading = false;
      this.totalItems = response.total;
    },
    handleSubmitForm(event) {
      this.getManagers();
      this.handleCloseManagerDialog();
    },
    handleOpenDialog() {
      this.manager_dialog = true;
    },
    handleCloseDialog() {
      this.manager_dialog = false;
    },
    handleRemoveManager(manager) {
      this.confirm_dialog = true;
      this.confirm_manager = manager;
    }
  },
  watch: {
    options: {
      handler() {
        this.getManagers();
      },
      deep: true
    },
    filter: function(value) {
      if (value == null) this.getManagers();
    }
  },
  created() {
    this.getManagers();
  }
};
</script>
